<app-banner [banner]="confirmedEmailPage.banner"></app-banner>
<div class="container-fluid minHeight">
  <div id="rsView">
    <div class="container mt-2">
      <div class="pgcontent">
        <div class="row mt-5">
          <div class="col-sm-8">
            <h4>Your password is changed successfully. Kindly click <span class="login-link" (click)="redirectToLogin()">here</span> to login.</h4>
          </div>
        </div>
      </div>
    </div>

    <input id="country" name="country" type="hidden" value="uk" />
    <input id="pgiid" name="pgiid" type="hidden" value="1331" />
  </div>
</div>
